<template>
  <div class="md-avatar-container">
    <div class="md-avatar" :class="[themeClass]">
      <slot></slot>
    </div>
    <div class="custom-badge" v-if="$slots.customBadge">
      <slot name="customBadge"></slot>
    </div>
    <div v-else>
      <div class="onlinestatus online" v-if="onlineStatus === 'online'"></div>
      <div class="onlinestatus offline" v-else-if="onlineStatus === 'offline'"></div>
    </div>
  </div>
</template>

<style lang="scss" src="./mdAvatar.theme"></style>
<style lang="scss" src="./mdAvatar.scss"></style>

<script>
import theme from '../../core/theme/mixins';

export default {
  name: 'md-avatar',
  mixins: [theme],
  props: {
    onlineStatus: {
      type: String,
    },
  },
};
</script>
